import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchCurrencyRates, editMultiCurrencies } from '../../actions/sales_actions';

import CurrencyManagement from '../../components/Settings/currencyManagement';

const validate = values => {
  const errors = {};
  if (!values.CountryFullName) {
    errors.CountryFullName = 'Required';
  }
  if (!values.CurrencyCode) {
    errors.CurrencyCode = 'Required';
  }
  if (!values.ExchangeRate) {
    errors.Rate = 'Required';
  }
  return errors;
};

const currencyManagement = reduxForm({
  form: 'currencyManagement',
  validate,
})(CurrencyManagement);

const selector = formValueSelector('currencyManagement');

function mapStateToProps(state) {
  const CountryFullName = selector(state, 'CountryFullName');
  const CurrencyCode = selector(state, 'CurrencyCode');
  const ExchangeRate = selector(state, 'ExchangeRate');

  return {
    CountryFullName,
    CurrencyCode,
    ExchangeRate,
    currencyRates: state.salesOrders.currencyRates,
    currencyRatesIsLoading: state.salesOrders.currencyRatesIsLoading,
    currencyRatesError: state.salesOrders.currencyRatesError,
    multiCurrenciesIsEditing: state.salesOrders.multiCurrenciesIsEditing,
    multiCurrenciesEdited: state.salesOrders.multiCurrenciesEdited,
    multiCurrenciesEditError: state.salesOrders.multiCurrenciesEditError,
  };
}

export default connect(mapStateToProps, { fetchCurrencyRates, editMultiCurrencies })(currencyManagement);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/currencyManagement.jsx